interface Props {
  /** El valor de src="" del embed de Google Maps. Null/vacío = no se renderiza nada. */
  url: string | null;
  className?: string;
}

/** Iframe de mapa embebido. No renderiza nada si `url` esta vacia o no es https. */
export function MapaEmbed({ url, className }: Props) {
  if (!url || !url.startsWith('https://')) return null;

  return (
    <iframe
      className={['h-72 w-full rounded-xl border-0 md:h-80', className].filter(Boolean).join(' ')}
      src={url}
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      title="Ubicación en el mapa"
    />
  );
}
